import React from 'react';
import EditIcon from './EditIcon';
import Container from './Container';

export default ({ onClick, children }) => (
  <Container>
    {children}
    <EditIcon onClick={onClick} />
  </Container>
);
